//引入VueRouter
import VueRouter from 'vue-router'
import { getSsoLoginUrl } from '@/utils/pathUtil';
// import store from '@/store'
//引入Luyou 组件

//创建router实例对象，去管理一组一组的路由规则
const router = new VueRouter({
	routes:[
		{
			path:'/',
			redirect:'/selectOrg'
		},
		{
			path:'/login',
			redirect:'/selectOrg'
		},
		{
			path: '/manage',
			component: () => import('@/views/manage/layout'),
			meta:{requireAuth:true},
			children: [
				{
					path: '',
					name: 'manage',
					component: () => import('@/views/manage'),
					meta:{requireAuth:true}
				},
				{
					path: 'postManage',
					name: 'postManage',
					component: () => import('@/views/manage/postManage'),
					meta:{requireAuth:true}
				},
				{
					path: 'orgSetting',
					name: 'orgSetting',
					component: () => import('@/views/manage/setOrg'),
					meta:{requireAuth:true}
				}
			]
		},
		{
			path: '/selectOrg',
			name: 'selectOrg',
			component: () => import('@/views/selectOrg'),
			meta:{requireAuth:true}
		},
		{
			path: '/managePeople',
			name: 'managePeople',
			component: () => import('@/views/managePeople'),
			meta:{requireAuth:true}
		},
		{
			path: '/historyRecord',
			name: 'historyRecord',
			component: () => import('@/views/yqTable/historyRecord'),
			meta:{requireAuth:true,keepAlive: true }// 开启缓存
		},
		//自制表单第一版
		{
			path:'/index',
			name: '',
			component: () => import('@/views/selfMadeForm')
		},
		// 自制表单第二版
		{
			path:'/selfMadeForm',
			name: 'selfMadeForm',
			component: () => import('@/views/selfMadeFormV2'),
			meta:{requireAuth:true}
		},
		// 社区
		{
			path:'/communityTableList',
			name: 'communityTableList',
			component: () => import('@/views/communityTableList'),
			meta:{requireAuth:true}
		},
		// 工会
		{
			path:'/tradeUnionTableList',
			name: 'tradeUnionTableList',
			component: () => import('@/views/tradeUnionTableList'),
		},
		{
			path:'/tradeunion',
			name: '',
			component: () => import('@/views/tradeUnionSelfMadeForm')
		},
		// 村财
		{
			path:'/yqTableList',
			name: 'yqTableList', 
			component: () => import('@/views/yqTable/yqTableList'),
			meta:{requireAuth:true}
		},
		{
			path:'/yqTable',
			name: 'yqTable', 
			component: () => import('@/views/yqTable/yqTableForm'),
			meta:{requireAuth:true}
		},
		{
			path:"/middlePage",
			name:'middlePage',
			component: () => import('@/views/yqTable/middlePage'),
			meta:{requireAuth:true}
		},
		// 二维码获取问答信息
		{
			path:"/codePage",
			name:'codePage',
			component: () => import('@/views/codePage/index'),
		}
	]
})

// 标记是否已完成SSO回调处理（避免重复校验）
let isSSOCallbackHandled = false;

router.beforeEach((to, from, next) => {
	// 如果已处理SSO回调（token已保存），直接放行
  if (isSSOCallbackHandled) {
    next();
    return;
  }

  const requiresAuth = to.meta.requireAuth;
	const token = localStorage.getItem('token')
	let userInfo = JSON.parse(localStorage.getItem("userInfo"))
	const isOrg = userInfo && userInfo.orgId
   if (requiresAuth &&(!token || !isOrg) ) {
    window.location.href = getSsoLoginUrl()
  } else {
		// token存在，标记回调已处理，避免重复校验
    isSSOCallbackHandled = true;
  }
	next(); // 否则，正常导航到目标路由
});

// 暴露标记，供App.vue修改
router.$isSSOCallbackHandled = () => {
  isSSOCallbackHandled = true;
};

//暴露router
export default router
